/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-sparse-arrays */
import React from 'react';
import CheckIcon from '../../../svgs/CheckIcon';
import DeactivateMerchantIcon from '../../../svgs/DeactivateMerchantIcon';
import DropdownEditIcon from '../../../svgs/DropdownEditIcon';
import EyeIcon from '../../../svgs/EyeIcon';
import MerchantDropdown from '../../MerchantDropdown';
import Styles from './UserManagementDropdown.module.scss';

interface IUserManagementDropdown{
  status:string;
  handleDropdown:any;
  data?:any;
}
const UserManagementDropdown = ({ status, handleDropdown, data }:IUserManagementDropdown) => {
  const dropdownDetails = data || [
    { title: 'View Details', icon: <EyeIcon width="12px" height="12px" /> },
    { ...status === 'pending' ? { title: 'Resend Invite', icon: <DropdownEditIcon /> } : status === 'active' ? { title: 'Deactivate Member', icon: <DeactivateMerchantIcon /> } : { title: 'Activate Member', icon: <CheckIcon width="12px" height="12px" color="rgba(0, 138, 0, 1)" /> } },
  ];
  return (
    <div className={Styles.wrapper}>
      <div className={Styles.wrapper__container}>

        <MerchantDropdown data={dropdownDetails} hasWrapper handleDropdown={handleDropdown} />
      </div>
    </div>
  );
};

export default UserManagementDropdown;
